module.exports = " <div class=ui> <div class=navbar-wrapper> <div class=navbar> <div class=left> </div> <div class=title>PACO-UI</div> <div class=right></div> </div> </div> <paco-ad show=true link=http://hcz.pingan.com title=平安好车主>开车能赚钱，买车全网最低</paco-ad> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/AdView.vue
// module id = 141
// module chunks = 1